import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import './css/syncfusion.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerLicense } from '@syncfusion/ej2-base';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { EnumProvider } from './contexts/EnumContext';
import { NotificationsProvider } from "./contexts/NotificationsContext";

registerLicense('ORg4AjUWIQA/Gnt2UlhhQlVMfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5adEZjUH1WcXdRR2da');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <EnumProvider>
                    <NotificationsProvider pollMs={15000}>
                        <App />
                    </NotificationsProvider>
                </EnumProvider>
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);

reportWebVitals();
